// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.properties.addresses.RentalManagerPropertyAddressRentZestimateWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { PropertyAddressRentZestimateResponseWebDto } from '../..';

interface RentZestimateParams {
  fullAddress: string;
  unit?: string;
}

export const RentalManagerPropertyAddressRentZestimateWebApiHandler_rentZestimate_Path =
  '/api/web/v1/properties/addresses/rentZestimate';

/**
 * Get rent zestimate for an address for non authenticated users
 */
export const RentalManagerPropertyAddressRentZestimateWebApiHandler_rentZestimate = (
  getParams: RentZestimateParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<RentZestimateParams, never, PropertyAddressRentZestimateResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerPropertyAddressRentZestimateWebApiHandler_rentZestimate_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
